// extracted by mini-css-extract-plugin
export default {"form":"styles_form__Bk3xB","btn":"styles_btn__VQxMF","title":"styles_title__vH+WX"};